import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

const PALETTE = ["#0A0A0A", "#8C6A3F", "#5B7A8C", "#A34A3A", "#6E8B5A", "#B89B5E", "#7A5C8C", "#9E9E9E"];
const MONTHS = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
const eur = (v) => `€ ${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

export function SpendChartCard() {
  const [d, setD] = useState(null);
  const [months, setMonths] = useState(12);
  useEffect(() => { api.get("/inventory/spend-by-month", { params: { months } }).then(r => setD(r.data)).catch(() => {}); }, [months]);
  if (!d) return null;
  const top = d.suppliers.slice(0, 7);
  const rest = d.suppliers.slice(7);
  const data = d.months.map(m => {
    const row = { label: `${MONTHS[Number(m.month.slice(5)) - 1]} ${m.month.slice(2, 4)}` };
    top.forEach(s => { row[s] = m[s] || 0; });
    if (rest.length) row["Altri"] = rest.reduce((a, s) => a + (m[s] || 0), 0);
    return row;
  });
  const keys = rest.length ? [...top, "Altri"] : top;
  return (
    <div className="card-dark p-6 mb-8" data-testid="spend-chart">
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="label-caps">Spesa materiali per fornitore</div>
          <div className="text-xs opacity-60 mt-1" data-testid="spend-chart-total">Totale periodo {eur(d.total)}</div>
        </div>
        <select className="input-dark !w-auto text-xs" value={months} onChange={e => setMonths(Number(e.target.value))} data-testid="spend-chart-months">
          <option value={6}>Ultimi 6 mesi</option><option value={12}>Ultimi 12 mesi</option><option value={24}>Ultimi 24 mesi</option>
        </select>
      </div>
      {keys.length === 0 ? <div className="text-sm opacity-60 py-10 text-center" data-testid="spend-chart-empty">Nessun arrivo merce registrato nel periodo.</div> : (
        <div style={{ height: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ left: 0, right: 8 }}>
              <XAxis dataKey="label" tick={{ fontSize: 11 }} stroke="#A3A3A3"/>
              <YAxis tick={{ fontSize: 11 }} stroke="#A3A3A3" tickFormatter={eur} width={70}/>
              <Tooltip formatter={(v) => eur(v)} cursor={{ fill: "rgba(0,0,0,0.04)" }}/>
              <Legend wrapperStyle={{ fontSize: 11 }}/>
              {keys.map((k, i) => <Bar key={k} dataKey={k} stackId="s" fill={PALETTE[i % PALETTE.length]}/>)}
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
